import z from "zod";

export const toneOfVoiceSchema = z.object({
  label: z.string().min(1, "Label is required").max(100, "Label must be 100 characters or fewer"),
  rawValue: z
    .string()
    .min(1, "Value is required")
    .max(5000, "Value must be 5000 characters or fewer"),
  isDefault: z.boolean(),
});

export type ToneOfVoiceFormValues = z.infer<typeof toneOfVoiceSchema>;

export type ViewState = "upload" | "manual" | "processing" | "review";
